"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _Events = _interopRequireWildcard(require("../../../../constants/Events"));
var _AppUtil = require("../../../../util/AppUtil");
var _AppConstants = _interopRequireDefault(require("../../../../constants/AppConstants"));
var _ViewMode = _interopRequireWildcard(require("../../../../constants/ViewMode"));
var _ApiConstants = _interopRequireDefault(require("../../../../constants/ApiConstants"));
var _CallbackTypes = _interopRequireDefault(require("../../../../constants/CallbackTypes"));
var _Branding = _interopRequireDefault(require("../../header/presentation/branding/Branding"));
var _Enums = require("../../../../constants/Enums");
var _ToolsBoardWrapperContainer = _interopRequireDefault(require("../../../../container/toolsBoard/ToolsBoardWrapperContainer"));
require("!style-loader!css-loader!./Preview.css");
var _class, _Preview;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let Preview = exports.default = (0, _mobxReact.observer)(_class = (_Preview = class Preview extends _react.default.Component {
  constructor(props) {
    super(props);
    this._className = "Preview";
    this._loggingService = _ServiceRegistry.default.getService("LoggingService");
    this.setPreviewRef = this.setPreviewRef.bind(this);
    this.isHUDBrandingSet = false;
  }
  rejectPromise(code) {
    return (0, _AppUtil.rejectAPIPromise)(code);
  }

  /**
   * @method
   * @description
   * It initialise the reference for preview dropin and provide interface for interaction
   */
  setPreviewRef(previewRef) {
    if (previewRef) {
      const appStore = _ServiceRegistry.default.getService("AppStore");
      this.dialogOpened = false;
      appStore.setPreviewRef(previewRef);
      setTimeout(() => {
        if (!appStore.isPreviewRefReadyEventFired) {
          _ServiceRegistry.default.getService("EventsService").sendEvent(_Events.InternalEvents.PREVIEW_REF_READY);
          appStore.setPreviewRefReadyEventFired(true);
        }
      }, 20);
      const previewConfig = appStore.getActionConfig("preview");
      previewRef.getPublicApis().then(api => {
        api.document.getMetadata().then(pdfMetadata => {
          const fileName = appStore.previewMetadata.fileName || "";
          const metadata = Object.assign(pdfMetadata, {
            pdfTitle: pdfMetadata.pdfTitle || fileName.replace(".pdf", "")
          });
          appStore.setPDFMetadata(metadata);
        }).catch(error => {
          this._loggingService.error(this._className, "Error in fetching PDF Metadata", JSON.stringify(error));
        });
        if (appStore.isInLinePreset || appStore.enableModernViewer && appStore.isSizedPreset) {
          api.app.customizeUIControl("DOWNLOAD", {
            visible: previewConfig.showDownloadPDF
          });
          api.app.customizeUIControl("PRINT", {
            visible: previewConfig.showPrintPDF
          });
        }
        if (appStore.isSizedPreset) {
          api.hud.dock(previewConfig.dockPageControls);
        }
        if (appStore.hideScrubberInLB) {
          api.app.customizeUIControl("SCRUBBER", {
            visible: false
          });
        }
        if (appStore.showBrandingInHUD && !this.isHUDBrandingSet) {
          api.hud.addUIControl(_Branding.default, "LEFT");
          this.isHUDBrandingSet = true;
        }
        _ServiceRegistry.default.getService("EventsService").registerEventListener(_Events.default.FULL_SCREEN_TOGGLE, ({
          inFullScreen
        }) => {
          if (appStore.enableModernViewer) {
            if ((0, _AppUtil.isMobileBrowser)()) {
              api.app.customizeUIControl("FILE_NAME_TOAST", {
                visible: inFullScreen
              });
            } else {
              api.app.customizeUIControl("FILE_NAME_TOAST", {
                visible: !inFullScreen
              });
              if (appStore.isSizedPreset) {
                api.rhp.show(inFullScreen);
                api.hud.show(!inFullScreen);
              }
            }
          }
        });
        _ServiceRegistry.default.getService("EventsService").registerEventListener(_Events.FilePreviewEvents.WAITING_ON_COMPLETE_PDF_BUFFER, () => {
          appStore.setFileLinearized(false);
        });
        api.app.registerPreviewCallback(_CallbackTypes.default.GET_FEATURE_FLAG, this.onGetFeatureFlag);
        api.app.registerPreviewCallback(_CallbackTypes.default.GET_LOCAL_FONT_PRIMING_DIALOG, this.onGetLocalFontPrimingDialog);
        api.app.registerPreviewCallback(_CallbackTypes.default.GET_ASSET_VERSION, this.onGetAssetVersion);
        api.app.registerPreviewCallback(_CallbackTypes.default.WAIT_FOR_DOC_SAVE_COMPLETION, this.onWaitForDocSaveCompletion);
        api.app.registerUserPrefThemeCallback(this.onGetUserThemePref);
      }).catch(error => this._loggingService.error(this._className, "Error in calling public apis ", error));
      previewRef.getApis("INTEGRATION_CONNECTOR", ["hud"]).then(apiObject => {
        apiObject.hud.setFitPageModeVisibility(previewConfig.showFitPageButton);
        apiObject.hud.setFitWidthModeVisibility(previewConfig.showFitWidthButton);
      }).catch(error => this._loggingService.error(this._className, "Error in calling hud apis ", error));
      previewRef.getApis("INTEGRATION_CONNECTOR", ["documentState", "documentEvents"]).then(apiObject => {
        apiObject.documentState.initialPageLoaded().then(() => {
          this.postFileLoaded(apiObject);
          _ServiceRegistry.default.getService("EventsService").sendEvent(_Events.default.FIRST_AJS_PAGE_RENDERED);
          previewRef.getPublicApis().then(api => api.rhp.subscribe(eventData => {
            _ServiceRegistry.default.getService("EventHandlerService")._handleDocumentStateUpdate({
              type: _Events.InternalEvents.SUBSCRIBE_TO_RHP,
              data: eventData
            });
          })).catch(error => `error here: ${error}`);
        }).catch(error => {
          this._loggingService.error(this._className, "Error in initial page load ", JSON.stringify(error));
          this.rejectPromise(_ApiConstants.default.API_RESPONSE.PREVIEW_RENDERING_FAILED);
          appStore.setEditAllowed(false);
          appStore.setFileLoaded(true);
        });
        apiObject.documentEvents.on("findUIStatus", bool => {
          appStore.setSearchOpen(bool);
          if (bool) {
            this.correctSearchUI();
          }
        });
        apiObject.documentState.dialogOpened().then(() => {
          appStore.setFileLoaded(true, true);
          this.dialogOpened = true;
          this.applyViewMode();
          _ServiceRegistry.default.getService("PerformanceService").setPreviewDialogOpened();
          this._loggingService.info(this._className, "File preview dialog shown.");
        }).catch(error => this._loggingService.error(this._className, "Error in calling dialog open api ", JSON.stringify(error)));
        apiObject.documentState.firstPageLoaded().then(() => {
          this.postFileLoaded(apiObject);
        }).catch(error => {
          this.rejectPromise(_ApiConstants.default.API_RESPONSE.PREVIEW_RENDERING_FAILED);
          this._loggingService.error(this._className, "Error in first page load ", JSON.stringify(error));
          appStore.setEditAllowed(false);
          appStore.setFileLoaded(true);
        });
      }).catch(error => this._loggingService.error(this._className, "Error in calling documentState and documentEvents apis ", error));

      // eslint-disable-next-line max-len
      if (previewConfig.saveBeforeUnload && (previewConfig.showAnnotationTools || previewConfig.enableFormFilling)) {
        window.addEventListener("beforeunload", e => {
          if (appStore.isDirty || appStore.fileStatus === _AppConstants.default.FILE_PROGRESS_STATUS.SAVING) {
            const confirmationMessage = "To save all edits into the original" + "file, click Save.";
            (e || window.event).returnValue = confirmationMessage; // Gecko + IE
            return confirmationMessage; // Gecko + Webkit, Safari, Chrome etc.
          }
          return undefined;
        });
      }
      _ServiceRegistry.default.getService("EventsService").initialize(previewRef);
    }
  }

  /**
   * @method
   * @description
   * It handles the position of search UI component once search icon is clicked.
   */
  correctSearchUI() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const previewConfig = appStore.getActionConfig("preview");
    if (this._searchInterval || !appStore.shouldAdjustSearchUIBelowTopBar && !previewConfig.adjustSearchUI) {
      return;
    }
    this._searchInterval = setInterval(() => {
      if (appStore.searchOpen && document.querySelector(".SearchInputUI__SearchInputUI___15hhd")) {
        const se = document.querySelector(".SearchInputUI__SearchInputUI___15hhd");
        const divId = appStore.getConfig().divId;
        const divElement = document.getElementById(divId);
        const rect = divElement.getBoundingClientRect();
        const top = Math.floor(rect.top);
        const right = Math.floor(rect.right - divElement.clientWidth);
        if (appStore.shouldAdjustSearchUIBelowTopBar) {
          se.style.top = `${top + 42}px`;
          if (appStore.enableModernViewer) {
            se.style.top = `${top + 55}px`;
            se.style.right = `${right + 73}px`;
          } else if (appStore.isIntegration) {
            se.style.right = `${right + 130}px`;
          } else {
            se.style.right = `${right + 50}px`;
          }
          if (se.style.width && se.style.width === "100%") {
            se.style.width = "378px";
          }
        } else if (previewConfig.adjustSearchUI) {
          se.style.top = `${top}px`;
          se.style.right = `${right}px`;
          se.style.maxWidth = `${divElement.clientWidth}px`;
        }
      }
    }, 10);
  }
  getDefaultViewMode() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const previewConfig = appStore.getActionConfig("preview");
    const {
      defaultViewMode
    } = previewConfig;
    if ((appStore.isLBPreset || appStore.isIntegration || appStore.isFWPreset) && (0, _AppUtil.isValidMobileViewMode)(defaultViewMode) && !appStore.showViewMode) {
      return "";
    }

    // eslint-disable-next-line max-len
    if (previewConfig.viewWithScrollButton && previewConfig.viewWithScrollButton.visible && !previewConfig.viewWithScrollButton.active) {
      const viewModes = [_ViewMode.default.FIT_PAGE, _ViewMode.default.FIT_WIDTH];
      if (viewModes.indexOf(previewConfig.defaultViewMode) !== -1) {
        previewConfig.defaultViewMode = _ViewMode.default.FIT_ONE_FULL_PAGE;
        return _ViewMode.default.FIT_ONE_FULL_PAGE;
      }
    }
    return defaultViewMode;
  }
  applyViewMode() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const previewConfig = appStore.getActionConfig("preview");
    const {
      defaultViewMode,
      documentOpenState
    } = previewConfig;
    const viewMode = documentOpenState && documentOpenState.viewMode || defaultViewMode;
    const {
      FIT_PAGE,
      FIT_WIDTH,
      TWO_COLUMN,
      TWO_COLUMN_FIT_PAGE,
      TWO_COLUMN_FIT_WIDTH,
      FIT_ONE_FULL_PAGE,
      SINGLE_PAGE
    } = _ViewMode.default;
    const validViewModes = [FIT_PAGE, FIT_WIDTH, TWO_COLUMN, TWO_COLUMN_FIT_PAGE, TWO_COLUMN_FIT_WIDTH, FIT_ONE_FULL_PAGE];
    if (validViewModes.includes(viewMode) || appStore.showViewMode && viewMode === SINGLE_PAGE) {
      appStore.previewRef.getPublicApis().then(api => api.document.setViewMode(_ViewMode.InternalViewMode[viewMode] || viewMode)).catch(error => this._loggingService.error(this._className, "Error in calling public apis ", error));
    }
  }
  onGetFeatureFlag(flag) {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const isViewSDKPublic = appStore.getConfig().isViewSDKPublic;
    const callbackService = _ServiceRegistry.default.getService("CallbackService");
    if (!isViewSDKPublic && callbackService.hasCallback(_CallbackTypes.default.GET_FEATURE_FLAG)) {
      return new Promise((resolve, reject) => {
        const callback = callbackService.getCallback(_CallbackTypes.default.GET_FEATURE_FLAG);
        callback(flag).then(response => {
          resolve(response);
        }).catch(err => {
          reject(err);
        });
      });
    }
    return Promise.reject(new Error(`No callback registered by viewer for ${_CallbackTypes.default.GET_FEATURE_FLAG}:
            ${flag} `, flag));
  }
  onGetAssetVersion() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const isViewSDKPublic = appStore.getConfig().isViewSDKPublic;
    const callbackService = _ServiceRegistry.default.getService("CallbackService");
    if (!isViewSDKPublic && callbackService.hasCallback(_CallbackTypes.default.GET_ASSET_VERSION)) {
      return new Promise((resolve, reject) => {
        const callback = callbackService.getCallback(_CallbackTypes.default.GET_ASSET_VERSION);
        callback().then(response => {
          resolve(response);
        }).catch(err => {
          reject(err);
        });
      });
    }
    return Promise.reject(new Error(`No callback registered for ${_CallbackTypes.default.GET_ASSET_VERSION}`));
  }
  onWaitForDocSaveCompletion() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const isViewSDKPublic = appStore.getConfig().isViewSDKPublic;
    const callbackService = _ServiceRegistry.default.getService("CallbackService");
    if (!isViewSDKPublic && callbackService.hasCallback(_CallbackTypes.default.WAIT_FOR_DOC_SAVE_COMPLETION)) {
      return new Promise((resolve, reject) => {
        const callback = callbackService.getCallback(_CallbackTypes.default.WAIT_FOR_DOC_SAVE_COMPLETION);
        callback().then(response => {
          resolve(response);
        }).catch(err => {
          reject(err);
        });
      });
    }
    // eslint-disable-next-line max-len
    return Promise.reject(new Error(`No callback registered for ${_CallbackTypes.default.WAIT_FOR_DOC_SAVE_COMPLETION}`));
  }
  onGetLocalFontPrimingDialog() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const isViewSDKPublic = appStore.getConfig().isViewSDKPublic;
    const callbackService = _ServiceRegistry.default.getService("CallbackService");
    if (!isViewSDKPublic && callbackService.hasCallback(_CallbackTypes.default.GET_LOCAL_FONT_PRIMING_DIALOG)) {
      return new Promise((resolve, reject) => {
        const callback = callbackService.getCallback(_CallbackTypes.default.GET_LOCAL_FONT_PRIMING_DIALOG);
        callback().then(response => {
          resolve(response);
        }).catch(err => {
          reject(err);
        });
      });
    }
    return Promise.reject(new Error(`No callback registered by viewer for ${_CallbackTypes.default.GET_LOCAL_FONT_PRIMING_DIALOG}`));
  }
  onGetUserThemePref() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const isViewSDKPublic = appStore.getConfig().isViewSDKPublic;
    const callbackService = _ServiceRegistry.default.getService("CallbackService");
    if (!isViewSDKPublic && callbackService.hasCallback(_CallbackTypes.default.GET_USER_THEME_PREF)) {
      return new Promise((resolve, reject) => {
        const callback = callbackService.getCallback(_CallbackTypes.default.GET_USER_THEME_PREF);
        callback().then(response => {
          resolve(response);
        }).catch(err => {
          reject(err);
        });
      });
    }
    return Promise.reject(`No callback registered by viewer for ${_CallbackTypes.default.GET_USER_THEME_PREF}`);
  }

  /**
   * @method
   * @description
   * It determines the document open state (viewMode, pageNumber, x, y) for the document from the preview config.
   *
   * @return {object} - The document open state object.
   */
  getDocumentOpenState() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const previewConfig = appStore.getActionConfig("preview");
    const {
      documentOpenState
    } = previewConfig;
    const defaultViewMode = documentOpenState && documentOpenState.viewMode || this.getDefaultViewMode();
    return _objectSpread(_objectSpread({}, documentOpenState), {}, {
      viewMode: defaultViewMode
    });
  }

  /**
   * @method
   * @description
   * It handles the post file preview operation like file permissions, view mode, background color.
   */
  postFileLoaded(apiObject) {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    // Check at every page load event
    const previewConfig = appStore.getActionConfig("preview");
    if (!this.previewMetadata.hasReadOnlyAccess) {
      apiObject.documentState.getDocumentSecurityInformation().then(docPermissions => {
        appStore.setEditAllowed((0, _AppUtil.calculateIsEditAllowed)(docPermissions, previewConfig.showAnnotationTools, previewConfig.enableFormFilling));
        const isPrintAllowed = (0, _AppUtil.calculateIsPrintAllowed)(docPermissions);
        if (!isPrintAllowed) {
          appStore.configStore.setShowPrint(false);
        }
        if (previewConfig.enableEncryptedWrite) {
          appStore.setCommentingAllowed((0, _AppUtil.calculateIsCommentingAllowed)(docPermissions));
        }
      }).catch(error => this._loggingService.error(this._className, "Error in calling getDocumentSecurityInformation api", error));
    }
    this.applyViewMode();
    const applyBGColor = () => {
      const docView = document.querySelector(".DocumentView__DocumentView___1NM7b");
      if (docView && docView.style) {
        docView.style.backgroundColor = appStore.getConfig().backgroundColor;
      }
    };
    applyBGColor();
    let counter = 0;
    this.bgInterval = setInterval(() => {
      if (counter < 200) {
        applyBGColor();
        counter += 1;
      } else if (this.bgInterval) {
        clearInterval(this.bgInterval);
      }
    }, 10);
    if (appStore.fileLoaded && !this.dialogOpened) {
      // Right now preview dropin is sending it twice.
      return;
    }
    _ServiceRegistry.default.getService("PerformanceService").setPreviewLoaded();
    _ServiceRegistry.default.getService("EventsService").sendEvent(_Events.InternalEvents.FILE_PREVIEW_READY);
    appStore.appReadyPromise.resolve();
    appStore.setAppReady(true);
    appStore.setFileLoaded(true);
    this.dialogOpened = false;
  }

  /**
   * @method
   * @description
   * Determines the font access configuration of a particular user
   * from the SAO list present within the user profile
   *
   * @return {string} - trial/premium
   * In cases where user profile function is not present, undefined value would
   * be returned.
   */
  getFontAccessTypeFromUserProfile() {
    var _window;
    let fontAccessType;
    if ((_window = window) !== null && _window !== void 0 && (_window = _window.adobeIMS) !== null && _window !== void 0 && _window.getUserProfile) {
      const userProfile = window.adobeIMS.getUserProfile();
      fontAccessType = "trial";
      if (userProfile) {
        const serviceAccounts = userProfile.serviceAccounts;
        if (serviceAccounts) {
          serviceAccounts.every(serviceAccount => {
            if (serviceAccount.serviceCode === "typekit" && serviceAccount.serviceLevel === "PAID_LVL_2") {
              fontAccessType = "premium";
              return false;
            }
            return true;
          });
        }
      }
    }
    return fontAccessType;
  }

  /**
   * @method
   * @description
   * Determines the font access configuration of a particular user(trial/premium)
   * that will be passed as props to the preview dropin
   *
   * @return {object} - Object having fontAccessType field in successful cases.
   * In cases where edit is not allowed or if it is not an express client id,
   * the fontAccessType field will not be present within the object.
   */
  getFontAccessConfig() {
    var _window2;
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const clientId = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.adobeid) === null || _window2 === void 0 ? void 0 : _window2.client_id;
    const expressClientIdList = ["quickactions_hz_webapp", "projectx_webapp"];
    if (appStore.isEditAllowed && expressClientIdList.includes(clientId)) {
      const fontAccessType = this.getFontAccessTypeFromUserProfile();
      if (fontAccessType) {
        return {
          fontAccessType
        };
      }
    }
    return {};
  }
  getProps(previewConfig) {
    const config = _ServiceRegistry.default.getService("AppStore").getConfig();
    if (config.isViewSDKPublic) {
      return {};
    }
    return _objectSpread({
      disableContextMenuAutoTrigger: previewConfig.disableContextMenuAutoTrigger,
      shouldDisableDownloadInContextMenu: previewConfig.shouldDisableDownloadInContextMenu,
      shouldCustomizeGlobalNavBar: false,
      alternateAssetUri: previewConfig.alternateAssetUri,
      isViewerDropinContext: false,
      // TODO:: Don't pass it at all
      fixedWidthLeftMargin: previewConfig.fixedWidthLeftMargin,
      fixedWidthRightMargin: previewConfig.fixedWidthRightMargin,
      hudBottomMargin: previewConfig.hudBottomMargin,
      enableLowResolutionRendition: !_ServiceRegistry.default.getService("FileApi").hasRenditions(),
      editDeepLink: previewConfig.editDeepLink,
      stickyTools: previewConfig.stickyTools,
      enableCustomLoader: previewConfig.enableCustomLoader,
      thumbnailSecondaryHeaderVerbs: previewConfig.thumbnailSecondaryHeaderVerbs,
      enableEditForFreeUsers: previewConfig.enableEditForFreeUsers,
      customReadingThemesSet: previewConfig.customReadingThemesSet
    }, this.getFontAccessConfig());
  }
  getDCAPIConfig(previewConfig) {
    const config = _ServiceRegistry.default.getService("AppStore").getConfig();
    if (config.isViewSDKPublic) {
      return {};
    }
    return {
      dcapiRenditionSize: previewConfig.dcapiRenditionSize,
      dcapiRenditionFormat: previewConfig.dcapiRenditionFormat
    };
  }

  /**
   * @method
   * @description
   * It creates 'appConfig' object, which will be passed to preview dropin
   */
  getAppConfig(previewConfig, appStore) {
    const appConfig = {
      useIframelessPrint: previewConfig.useIframelessPrint,
      enableFallbackPrint: previewConfig.printStrategy === _Enums.printStrategy.BROWSER_OR_HTML_PRINT,
      enableInlineOrganize: previewConfig.enableInlineOrganize,
      disableProtectedPDFCancelButton: previewConfig.disableProtectedPDFCancelButton,
      printWithWindow: previewConfig.printStrategy === _Enums.printStrategy.INTEGRATION_PRINT,
      defaultRHPFeature: previewConfig.defaultRHPFeature,
      usePartialEdit: previewConfig.usePartialEdit,
      usePremiumIndicator: previewConfig.usePremiumIndicator,
      shouldEnableEditGenAI: previewConfig.shouldEnableEditGenAI,
      caretMode: previewConfig.enableCaretMode,
      scrollToShowCaret: previewConfig.scrollToShowCaret,
      showCaretOnPDFOpen: previewConfig.showCaretOnPDFOpen,
      showAdvancedFontPicker: previewConfig.showAdvancedFontPicker,
      disableEditFeatures: previewConfig.disableEditFeatures,
      enableNumberPages: previewConfig.enableNumberPages,
      isDemoMode: previewConfig.isDemoMode,
      showEditOnTextSelection: previewConfig.showEditOnTextSelection
    };
    if (appStore.enableModernViewer) {
      if (appStore.isLBPreset || appStore.isInLinePreset || appStore.isSizedPreset) {
        appConfig.showQuickTools = false;
      }
      if (appStore.isSizedPreset) {
        appConfig.showHUD = !((0, _AppUtil.isMobileBrowser)() || appStore.showFullScreenModal);
      }
      if ("showRHP" in previewConfig) {
        appConfig.showRHP = previewConfig.showRHP;
      }
    }
    return appConfig;
  }

  /**
   * @method
   * @description
   * It creates 'featureConfig' object, which will be passed to preview dropin
   */
  getFeatureConfig(previewConfig, appStore) {
    var _previewConfig$genAIC, _previewConfig$genAIC2;
    return {
      DOWNLOAD: previewConfig.showDownloadPDF,
      EDIT: previewConfig.enableEdit,
      THUMBNAILS: previewConfig.showThumbnails,
      BOOKMARKS: previewConfig.showBookmarks,
      CROP_PAGES: previewConfig.enableCropPages,
      READ_ALOUD: previewConfig.enableReadAloud,
      DIGITAL_SIGNATURE_CONFIG: previewConfig.digitalSignatureConfig || {},
      NUMBER_PAGE: previewConfig.enableNumberPages,
      PDF_JAVASCRIPT: appStore.getConfig().enablePDFJavaScript,
      OVERPRINT_SUPPORT: appStore.getConfig().enableOverprintSupport,
      ACROFORM_VALIDATION_FORMATTING: previewConfig.enableAcroformValidationFormatting,
      GENAI_QNA: !!((_previewConfig$genAIC = previewConfig.genAIConfig) !== null && _previewConfig$genAIC !== void 0 && _previewConfig$genAIC.enableQnA),
      GENAI_OUTLINE: !!((_previewConfig$genAIC2 = previewConfig.genAIConfig) !== null && _previewConfig$genAIC2 !== void 0 && _previewConfig$genAIC2.enableOutline),
      READ_ONLY_MODE: previewConfig.enableReadOnlyMode
    };
  }
  getPreviewDropinComponent() {
    var _previewConfig$viewWi;
    const appStore = _ServiceRegistry.default.getService("AppStore");
    let scrollEventObj;
    if (appStore.isInLinePreset) {
      scrollEventObj = {
        on: (type, fn) => appStore.setWindowScrollListener(fn),
        unregister: () => appStore.setWindowScrollListener(undefined)
      };
    }
    const previewConfig = appStore.getActionConfig("preview");
    this.previewMetadata = appStore.previewMetadata;
    if (!this.previewMetadata) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    const uiControlsConfig = {
      ROTATE_VIEW_CONTROL: {
        visible: previewConfig.showRotateViewControl
      },
      ZOOM_CONTROL: {
        visible: previewConfig.showZoomControl
      },
      PAGE_NAVIGATION_CONTROL: {
        visible: previewConfig.showPageNavigationControl
      },
      UNSUPPORTED_FEATURE_ALERT: {
        visible: !previewConfig.disableUnsupportedFeatureAlert
      },
      FIRST_TIME_ENTER_EDIT: {
        firstTimeEnterEdit: previewConfig.firstTimeEnterEdit
      },
      OPEN_IN_DESKTOP_FOR_UNSUPPORTED_FEATURE: {
        visible: previewConfig.openInDesktopForUnsupportedFeature
      },
      VIEW_WITH_SCROLL: {
        visible: (_previewConfig$viewWi = previewConfig.viewWithScrollButton) === null || _previewConfig$viewWi === void 0 ? void 0 : _previewConfig$viewWi.visible
      },
      FULL_SCREEN: {
        visible: previewConfig.showFullScreenViewButton
      }
    };
    if (appStore.hideFileNameToast) {
      uiControlsConfig.FILE_NAME_TOAST = {
        visible: false
      };
    } else if (typeof previewConfig.showFileNameToast === "boolean") {
      uiControlsConfig.FILE_NAME_TOAST = {
        visible: previewConfig.showFileNameToast
      };
    }
    if (typeof previewConfig.showDocumentPermissionsToast === "boolean") {
      uiControlsConfig.DOCUMENT_PERMISSIONS_TOAST = {
        visible: previewConfig.showDocumentPermissionsToast
      };
    }
    if (typeof previewConfig.viewDocumentProperties === "boolean") {
      uiControlsConfig.VIEW_DOCUMENT_PROPERTIES = {
        visible: previewConfig.viewDocumentProperties
      };
    }
    if (typeof previewConfig.showScrubber === "boolean") {
      uiControlsConfig.SCRUBBER = {
        visible: previewConfig.showScrubber
      };
    }
    if (appStore.enableModernViewer) {
      if (this.previewMetadata.hasReadOnlyAccess && previewConfig.showAnnotationTools) {
        uiControlsConfig.COMMENT_STICKYNOTE_CONTROL = {
          visible: false
        };
        uiControlsConfig.COMMENT_TEXT_CONTROL = {
          visible: false
        };
        uiControlsConfig.COMMENT_HIGHLIGHT_CONTROL = {
          visible: false
        };
        uiControlsConfig.COMMENT_UNDERLINE_CONTROL = {
          visible: false
        };
        uiControlsConfig.COMMENT_STRIKEOUT_CONTROL = {
          visible: false
        };
        uiControlsConfig.COMMENT_DRAW_CONTROL = {
          visible: false
        };
        uiControlsConfig.COMMENT_INSERT_CONTROL = {
          visible: false
        };
        uiControlsConfig.COMMENT_REPLACE_CONTROL = {
          visible: false
        };
      }
      if (previewConfig.annotationUIConfig && "showCommentsPanel" in previewConfig.annotationUIConfig) {
        uiControlsConfig.COMMENTS_PANEL = {
          visible: previewConfig.annotationUIConfig.showCommentsPanel
        };
      }
      if (!previewConfig.enableFreeTextAnnotationTool && previewConfig.showAnnotationTools) {
        uiControlsConfig.COMMENT_TEXT_CONTROL = {
          visible: false
        };
      }
    }
    if (previewConfig.forceShowCommentingTools === true) {
      // Required for dc-web
      uiControlsConfig.FORCE_SHOW_COMMENTING_TOOLS = {
        visible: previewConfig.forceShowCommentingTools
      };
    }
    const Dropin = this.props.previewDropin;
    const appConfig = this.getAppConfig(previewConfig, appStore);
    const featureConfig = this.getFeatureConfig(previewConfig, appStore);
    return /*#__PURE__*/_react.default.createElement(Dropin, {
      previewRef: ref => this.setPreviewRef(ref),
      config: _objectSpread({
        showLHP: previewConfig.showLeftHandPanel,
        showHUD: previewConfig.showPageControls,
        shouldDockHUD: previewConfig.dockPageControls,
        shouldLoadContextBoardDropin: false,
        shouldRenderCommentsDropin: previewConfig.shouldRenderCommentsDropin,
        shouldRenderSignAuthoringDropin: previewConfig.shouldRenderSignAuthoringDropin,
        shouldRenderVisualizerDropin: previewConfig.shouldRenderVisualizerDropin,
        assetUri: this.previewMetadata.id,
        shouldShowDownloadButtonInHud: previewConfig.showDownloadPDFInPageControl,
        filetype: this.previewMetadata.mimeType,
        path: "/external",
        docTitle: this.previewMetadata.fileName,
        shouldRenderPersonalCommentsDropin: previewConfig.showAnnotationTools,
        shouldRenderAcroForm: previewConfig.enableFormFilling && appStore.isEditAllowed,
        selectivelyRenderAnnotsFlag: appStore.getAnnotationFlag(),
        context: "integration",
        docViewBgColor: appStore.getConfig().backgroundColor,
        enableLinearization: previewConfig.enableLinearization,
        enableFillSign: previewConfig.enableFillSign,
        forceSetExternalMetadata: previewConfig.forceSetExternalMetadata,
        shouldUseModernViewer: previewConfig.enableModernViewer,
        enablePdfRequestSignatures: previewConfig.enablePdfRequestSignatures,
        useViewSDKForAcroformSubmit: previewConfig.emitSubmitFormEvent,
        enableEncryptedWrite: previewConfig.enableEncryptedWrite,
        enableAccessibilityByDefault: previewConfig.enableAccessibilityByDefault,
        enablePDFJavaScriptOverridePromise: appStore.getEnablePDFJavaScriptOverridePromise(),
        shouldUseMobileModernViewer: previewConfig.enableMobileModernViewer,
        linearizationBlockSize: appStore.getConfig().linearizationBlockSize,
        suppressPasswordDialog: previewConfig.suppressPasswordDialog,
        fallbackPrintTimeout: previewConfig.fallbackPrintTimeout,
        filePath: this.previewMetadata.filePath,
        fillSignConfig: previewConfig.fillSignConfig,
        showPremiumIconForNonDCWebClients: previewConfig.showPremiumIconForNonDCWebClients,
        shouldUseProgressiveRendering: previewConfig.shouldUseProgressiveRendering,
        hideStickyToolOnTap: previewConfig.hideStickyToolOnTap,
        enableThemeSwitcher: previewConfig.enableThemeSwitcher,
        showAssistantInRHP: previewConfig.showAssistantInRHP,
        enableRHPResizing: previewConfig.enableRHPResizing,
        shouldRenderESignOverlayDropin: previewConfig.shouldRenderESignOverlayDropin,
        isPreviewSwitching: appStore.isPreviewSwitching,
        enableCNPDF: previewConfig.enableCNPDF,
        shouldDeferLoadOverlays: previewConfig.shouldDeferLoadOverlays,
        rhpSkeletonDropinId: previewConfig.rhpSkeletonDropinId,
        bottomBannerConfig: previewConfig.bottomBannerConfig,
        renderNotificationBannerBeforeDoc: previewConfig.renderNotificationBannerBeforeDoc
      }, this.getProps(previewConfig)),
      appConfig: appConfig,
      documentOpenState: this.getDocumentOpenState(),
      UIControlsConfig: uiControlsConfig,
      featureConfig: featureConfig,
      scrollEventObj: scrollEventObj,
      dcApiConfig: this.getDCAPIConfig(previewConfig)
    });
  }
  render() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const sdkAppClass = appStore.shouldLoadToolsBoardDropin ? "sdk-App" : "";
    const previewClass = appStore.shouldLoadToolsBoardDropin ? "preview" : "";
    const previewDropinComponent = this.getPreviewDropinComponent();
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, appStore.shouldLoadToolsBoardDropin && appStore.isEditEnabled ? /*#__PURE__*/_react.default.createElement("div", {
      className: `${sdkAppClass}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "side-Nav"
    }, /*#__PURE__*/_react.default.createElement(_ToolsBoardWrapperContainer.default, null)), /*#__PURE__*/_react.default.createElement("div", {
      className: `${previewClass}`
    }, previewDropinComponent)) : previewDropinComponent);
  }
}, _Preview.propTypes = {
  previewDropin: _propTypes.default.objectOf(_propTypes.default.any).isRequired
}, _Preview)) || _class;